import {
  Condition,
  DiscountBenefit,
  Gift,
  ProductPromotion,
  VoucherPromotion,
} from '@teko/ecommerce';
import { ExtraCustomPromotion, ExtraPromotion } from './magento';

export interface PromotionResponse extends Omit<ProductPromotion, 'condition'> {
  isDefault: boolean;
  isPrivate: boolean;
  condition: Condition & {
    skus: {
      sku: string;
    }[];
  };
  applySellerIds: number[];
}

export enum BENEFIT_TYPE {
  voucher = 'voucher',
  gifts = 'gifts',
  discount = 'discount',
}

export enum PROMOTION_TYPE {
  magento = 'magento',
  customMagento = 'customMagento',
}

export type ProductDetailBenefit =
  | VoucherPromotion
  | Gift[]
  | DiscountBenefit
  | ExtraPromotion
  | ExtraCustomPromotion;

export interface PromotionCondition extends Partial<Condition> {
  hasProductCondition?: boolean;
}

export interface ProductDetailPromotion
  extends Omit<Partial<PromotionResponse>, 'benefit' | 'condition'> {
  promotionType?: string;
  benefit: {
    type?: string;
    data: ProductDetailBenefit;
  };
  condition?: PromotionCondition;
}

export interface ProductDetailPromotionV2
  extends Omit<Partial<PromotionResponse>, 'benefit' | 'condition'> {
  promotionType?: string;
  benefit: PromotionResponse['benefit'];
  condition?: PromotionCondition;
}
